import { ENDPOINTS } from "utils/endpoints";
import { http } from "utils/http";

export const getToolbarEnumerationFilter = (enumerationType) => http({
    url: ENDPOINTS.enumeration,
    method: 'get',
     params: {
        enumerationType
     }
}).then((response) => (response.data))